import './MonthNav.css';
import { formatMonthKey } from '../../domain/leaderboard/types';

export interface MonthNavProps {
  monthKey: string;
  onPrevious: () => void;
  onNext: () => void;
  isNextDisabled?: boolean;
}

export function MonthNav({ monthKey, onPrevious, onNext, isNextDisabled }: MonthNavProps) {
  return (
    <div className="month-nav">
      <button className="month-nav__button" onClick={onPrevious} aria-label="Previous month">
        <span aria-hidden="true">{'<'}</span>
      </button>
      <h2 className="month-nav__title">{formatMonthKey(monthKey)}</h2>
      <button
        className="month-nav__button"
        onClick={onNext}
        disabled={isNextDisabled}
        aria-label="Next month"
      >
        <span aria-hidden="true">{'>'}</span>
      </button>
    </div>
  );
}
